import React from 'react';
import { connect } from 'react-redux';
import { intlShape, injectIntl } from 'react-intl';
import { isChrome, isIOS, isMobile, isTablet } from 'react-device-detect';

import { DateTimeIcon } from '../../../../images/icons/WrapSvg';

import TextField from '@material-ui/core/TextField';
import Close from '@material-ui/icons/Close';

import { bindActionCreators } from 'redux';
import * as actions from '../../../../actions/api.form.actions';

import Task from './Task';

function formatDateTime(d) {
    if (d instanceof Date) {
        function pad(s) {
            return s < 10 ? '0' + s : s;
        }
        return [d.getFullYear(), pad(d.getMonth() + 1), pad(d.getDate())].join('-') + ' ' + [pad(d.getHours()), pad(d.getMinutes())].join(':');
    }
    return d;
}

function formatDateTimeLoad(d) {
    if (d instanceof Date) {
        function pad(s) {
            return s < 10 ? '0' + s : s;
        }
        return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/') + ' ' + [pad(d.getHours()), pad(d.getMinutes())].join(':');
    }
    return d;
}


function parseDate(input) {
    const date = input.replace('T', ' ').split(' ')[0];
    const time = input.replace('T', ' ').split(' ')[1];
    // eslint-disable-next-line
    const format = date.match(/^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/) ? 'dd/mm/yyyy' : 'yyyy-mm-dd'; // default format
    var parts = date.match(/(\d+)/g), i = 0, fmt = {};
    console.log(format, parts, date, time, input);
    // extract date-part indexes from the format
    format.replace(/(yyyy|dd|mm)/g, function (part) { fmt[part] = i++; });

    return new Date(parts[fmt['yyyy']], parts[fmt['mm']] - 1, parts[fmt['dd']]).setHours(time.split(':')[0], time.split(':')[1], 0, 0);
}

function isCorrectDate(date) {
    var safariDateTime = /^([1-9]|([012][0-9])|(3[01]))\/([0]{0,1}[1-9]|1[012])\/\d\d\d\d (20|21|22|23|[0-1]?\d):[0-5]?\d$/;
    var chromeDateTime = /^[0-9]{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1]) (2[0-3]|[01][0-9]):[0-5][0-9]/;
    return !!date.replace('T', ' ').match(chromeDateTime) || !!date.replace('T', ' ').match(safariDateTime)
}

function check(date, conditions) {
    if (!conditions) return false;
    else {
        if (!date) return false;
        else {
            if (!isCorrectDate(date)) return true;
            var aux1 = new Date(parseDate(date));
            if (conditions.min) {
                var aux2 = new Date(parseDate(conditions.min));
                console.log(aux1, conditions.min, aux2);
                if (aux1.valueOf() < aux2.valueOf()) {
                    return false;
                }
            }
            if (conditions.max) {
                var aux3 = new Date(parseDate(conditions.max));
                if (aux1.valueOf() > aux3.valueOf()) {
                    return false;
                }
            }
        }
    }
    return true;
}

class Index extends React.Component {

    state = {
        valor: undefined,
        comment: '',
        point: 0,
        correction: 0,
        message: undefined,
        intervalId: undefined,
        desactivado: false,
        disabledmodoTest: false 
    };


    static getDerivedStateFromProps(props, state) {

        const { data, parentDeactivated } = props;
        if (data !== state.data || parentDeactivated !== state.parentDeactivated) {
            state.data = data;
            state.valor = data.valor ? ((isChrome || isIOS || isMobile || isTablet) ? data.valor : formatDateTimeLoad(new Date(parseDate(data.valor)))) : '';
            state.desactivado = data.desactivado;
            state.parentDeactivated = parentDeactivated;

            const conditions = data && data.alertable && (data.alertable.inferior || data.alertable.superior) ? {} : undefined;
            const fecha =  props.instance && props.instance.instancia && props.instance.instancia.fechafin ? new Date(props.instance.instancia.fechafin.date) : new Date();
            console.log(props.instance, fecha);
            if (data && data.alertable && data.alertable.inferior) {
                conditions.min = formatDateTime(new Date(fecha.getTime() - ((parseInt(data.alertable.inferior, 10) + (data.alertable.limiteinferior ? 0 : 1)) * 60 * 60 * 1000)));
            }
            if (data.alertable && data.alertable.superior) {
                conditions.max = formatDateTime(new Date(fecha.getTime() + ((parseInt(data.alertable.superior, 10) - (data.alertable.limitesuperior ? 0 : 1)) * 60 * 60 * 1000)));
            }
            state.disabledmodoTest = data.modoTest  && !!state.valor;
            state.conditions = conditions;
            console.log("conditions", conditions)
            return state;
        }
        return null;
    }

    handleDateChange = (name, date, conditions, range) => {

        const error = conditions && date
            ? check(date, conditions)
                ? false
                : true
            : false;
        this.props.setValue(name, date && isCorrectDate(date) ? formatDateTime(new Date(parseDate(date))).replace(" ", "T") : '', '', false, {});
        this.setState({ valor: date ? date : '', error: error });
    };

    handleClick = (name) => {
        if (!this.props.data.disabled && document.getElementById(name)) {
            document.getElementById(name).focus();
        }
    };

    handleDeactive = (data, checked) => {
        this.props.setValue(data.codigo, undefined, '', checked, {});
        this.setState({ desactivado: checked, valor: undefined });
    };


    handleFocus = () => {
        const { data, valor } = this.state;
        if(data.modoTest && valor) {
            this.setState({  disabledmodoTest:  true });
        }
    }

    component = (name, intl, disabled, style, conditions, range) => {
        const { data, valor, disabledmodoTest } = this.state;
        if (disabled) {
            return (
                <span className="barlow_regular_textwrap c_slate text_align_left">
                    {this.state.valor}
                </span>
            );
        } else {
            if (style === 'NORMAL' || !conditions) {
                return (
                    <div className="flex_full_row align_center">
                        <TextField
                            name={name}
                            id={name}
                            label={intl.formatMessage({ id: 'date_field_label' })}
                            type="datetime-local"
                            value={valor}
                            disabled={disabledmodoTest && !!valor}
                            onFocus={this.handleFocus} 
                            format={'DD/MM/YYYY HH:MM'}
                            placeholder='DD/MM/YYYY HH:MM'
                            error={!!this.state.error || (!!valor && !isCorrectDate(valor))}
                            helperText={
                                valor && !isCorrectDate(valor)
                                    ? "Formato de fecha incorrecto"
                                    : this.state.error
                                        ? intl.formatMessage({ id: 'error_date_field_future' })
                                        : ''
                            }
                            onChange={(event) => this.handleDateChange(name, event.target.value)}
                            className={'flex_full_row'}
                            InputLabelProps={{ shrink: true }}
                        />
                        {!data.modoTest &&
                            <Close
                                className="c_lipstick hand"
                                onClick={(event) => this.handleDateChange(name, undefined)}
                            />
                        }
                    </div>
                );
            } else {
                return (
                    <div className="flex_full_row align_center">
                        <TextField
                            name={name}
                            id={name}
                            label={intl.formatMessage({ id: 'date_field_label' })}
                            type="datetime-local"
                            value={valor}
                            disabled={disabledmodoTest && !!valor}
                            onFocus={this.handleFocus} 
                            onChange={(event) =>
                                this.handleDateChange(name, event.target.value, conditions, range)
                            }
                            format={'DD/MM/YYYY HH:MM'}
                            placeholder='DD/MM/YYYY HH:MM'
                            error={!!this.state.error || (!!valor && !isCorrectDate(valor))}
                            helperText={
                                valor && !isCorrectDate(valor)
                                    ? "Formato de fecha incorrecto"
                                    : this.state.error
                                        ? intl.formatMessage({ id: 'error_date_field_future' })
                                        : ''
                            }
                            className={'flex_full_row'}
                            InputLabelProps={{ shrink: true }}
                            InputProps={{ inputProps: conditions }}
                        />
                        {!data.modoTest &&
                            <Close
                                className="c_lipstick hand"
                                onClick={(event) => this.handleDateChange(name, undefined)}
                            />
                        }
                    </div>
                );
            }
        }
    };

    render() {
        const { valor, desactivado, parentDeactivated, conditions } = this.state;
        const { data, last, intl, editable } = this.props;
        console.log("conditions", conditions);
        return (
            <Task
                key={data.codigo}
                data={data}
                value={valor && valor.length === 16 && isCorrectDate(valor) ? true : undefined}
                red={conditions && valor ? !check(valor, conditions) : false}
                icon={<DateTimeIcon color="primary" />}
                text="type_label_date"
                last={last}
                editable={editable}
                desactivado={desactivado || parentDeactivated}
                parentDeactivated={parentDeactivated}
                component={this.component(
                    data.codigo,
                    intl,
                    !editable || data.disabled || parentDeactivated || desactivado,
                    data.estilo,
                    conditions,
                    data.alertable
                )}
                onClick={() => this.handleClick(data.codigo)}
                onDeactive={this.handleDeactive}
            />
        );
    }
}

Index.propTypes = {
    intl: intlShape.isRequired,
};

const mapStateToProps = (state) => {
    return {
        instance: state.instance,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions), dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(injectIntl(Index));



// WEBPACK FOOTER //
// ./src/components/complex/forms/types/DateTime.js